import Vue from 'vue'
import { URL_TRADE_REQUESTS } from '@/constants/urls.js'
import { LOT_REQUEST_STATUSES } from '@/constants/business.js'
import { TRADE_REQUEST_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [TRADE_REQUEST_MANAGEMENT.STATE.REQUESTS]: {
    [LOT_REQUEST_STATUSES.CREATED]: null,
    [LOT_REQUEST_STATUSES.INPROCESS]: null,
    [LOT_REQUEST_STATUSES.REJECTED]: null,
    [LOT_REQUEST_STATUSES.APPROVED]: null

  },
  [TRADE_REQUEST_MANAGEMENT.STATE.CURRENT_REQUEST]: null
}

const actions = {
  async [TRADE_REQUEST_MANAGEMENT.ACTIONS.GET_TRADE_REQUESTS] ({ dispatch, commit }, model) {
    const status = model.params.status
    model = {
      url: `${Vue.getBusinessHost()}${URL_TRADE_REQUESTS}/${model.requestType}?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(TRADE_REQUEST_MANAGEMENT.MUTATIONS.GET_TRADE_REQUESTS, {
      requests: resp.data,
      status
    })
  },
  async [TRADE_REQUEST_MANAGEMENT.ACTIONS.GET_TRADE_REQUEST_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TRADE_REQUESTS}/${model.requestType}/${model.requestId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(TRADE_REQUEST_MANAGEMENT.MUTATIONS.GET_TRADE_REQUEST_ADMIN, resp.data)
  },
  async [TRADE_REQUEST_MANAGEMENT.ACTIONS.PROCESS_TRADE_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_TRADE_REQUESTS}/${model.requestType}/${model.requestId}/process`,
      model: model.process
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [TRADE_REQUEST_MANAGEMENT.ACTIONS.RECALL_LOT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getAdminHost()}${URL_TRADE_REQUESTS}/recall/${model.lotId}`,
      model: model.request
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [TRADE_REQUEST_MANAGEMENT.ACTIONS.CLEAR_TRADE_REQUESTS] ({ commit }, status) {
    commit(TRADE_REQUEST_MANAGEMENT.MUTATIONS.CLEAR_TRADE_REQUESTS, status)
  },
  async [TRADE_REQUEST_MANAGEMENT.ACTIONS.CLEAR_TRADE_REQUEST_ADMIN] ({ commit }) {
    commit(TRADE_REQUEST_MANAGEMENT.MUTATIONS.CLEAR_TRADE_REQUEST_ADMIN)
  }
}

const mutations = {
  [TRADE_REQUEST_MANAGEMENT.MUTATIONS.GET_TRADE_REQUESTS] (state, model) {
    state[TRADE_REQUEST_MANAGEMENT.STATE.REQUESTS][model.status] = model.requests
  },
  [TRADE_REQUEST_MANAGEMENT.MUTATIONS.GET_TRADE_REQUEST_ADMIN] (state, request) {
    state[TRADE_REQUEST_MANAGEMENT.STATE.CURRENT_REQUEST] = request
  },
  [TRADE_REQUEST_MANAGEMENT.MUTATIONS.CLEAR_TRADE_REQUESTS] (state, status) {
    state[TRADE_REQUEST_MANAGEMENT.STATE.REQUESTS][status] = null
  },
  [TRADE_REQUEST_MANAGEMENT.MUTATIONS.CLEAR_TRADE_REQUEST_ADMIN] (state) {
    state[TRADE_REQUEST_MANAGEMENT.STATE.CURRENT_REQUEST] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
